import * as React from 'react'
import { useParams } from 'react-router-dom'
import { FaIcon, faPrint, faFileInvoice } from '@/lib/fa'
import Tooltip from '@/modules/drivers/shared/ToolTip'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import usePrintViolations from '../hooks/usePrintViolations'
import { getExcludedViolations } from '@/modules/drivers/stores/violationPrintStore'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import { useSideSelectionStore } from '@/modules/drivers/stores/sideSelectionStore'

const ViolationsSelectedActionBar: React.FC = () => {
  const { t } = useLocalize()
  const { companyId } = useParams<{ companyId: string }>()
  const {
    busyTooltip,
    handlePrintDriverViolations,
    handlePrintDriverViolationsWithActivities,
    handlePrintGroupedViolations,
    handlePrintInstruction,
  } = usePrintViolations()
  const { drivers } = useDrivers()

  const {sideCheckedIds} = useSideSelectionStore()

  const printArgs = () => ({
    selectedIds: sideCheckedIds,
    drivers: drivers ?? [],
    companyId,
    excludedViolations: getExcludedViolations(companyId),
  })

  return (
    <div className="tw-flex tw-z-[100] tw-w-full tw-flex-shrink-0 tw-items-center tw-justify-between tw-border-b tw-border-[#e5e6e6] tw-bg-[#fafbff] tw-px-4 tw-py-3">
      <div className="tw-absolute -tw-bottom-1.5 tw-left-3">
        <div className="tw-absolute -tw-top-1.5 !tw-z-10 tw-h-2 tw-w-2 tw-bg-[#F1F4FF]"></div>
        <div className="tw-h-2 tw-w-2 tw-rotate-45 tw-bg-primary"></div>
      </div>

      <div className="tw-flex tw-flex-col tw-items-start tw-gap-5 lg:tw-flex-row lg:tw-items-center">
        <div className="tw-flex tw-items-center tw-gap-5">

          <div className="tw-flex tw-items-center tw-gap-2">
            <Tooltip
              text={t('driverModule.print-driver-violations')}
              onClick={() => handlePrintDriverViolations(printArgs())}
              blockedText={busyTooltip}
            >
              <div className="tw-flex tw-h-5 tw-items-center tw-gap-2 tw-rounded-lg tw-px-2 hover:tw -bg-[#e5e6e6]">
                <FaIcon
                  icon={faPrint}
                  className="tw-h-4 tw-w-4 tw-text-[#2448bb]"
                />
                <span className="tw-text-sm tw-font-medium tw-text-[#2448bb]">
                  {t('driverModule.print-driver-violations')}
                </span>
              </div>
            </Tooltip>

            <div className="tw-h-[18px] tw-w-px tw-bg-[#e5e6e6]"></div>

            <Tooltip
              text={t('driverModule.print-driver-violations-with-activities')}
              onClick={() =>
                handlePrintDriverViolationsWithActivities(printArgs())
              }
              blockedText={busyTooltip}
            >
              <div className="tw-flex tw-h-5 tw-items-center tw-gap-2 tw-rounded-lg tw-px-2 hover:tw-bg-[#e5e6e6]">
                <FaIcon
                  icon={faPrint}
                  className="tw-h-4 tw-w-4 tw-text-[#2448bb]"
                />
                <span className="tw-text-sm tw-font-medium tw-text-[#2448bb]">
                  {t('driverModule.print-driver-violations-with-activities')}
                </span>
              </div>
            </Tooltip>

            <div className="tw-h-[18px] tw-w-px tw-bg-[#e5e6e6]"></div>

            <Tooltip
              text={t('driverModule.print-grouped-violations')}
              onClick={() => handlePrintGroupedViolations(printArgs())}
              blockedText={busyTooltip}
            >
              <div className="tw-flex tw-h-5 tw-items-center tw-gap-2 tw-rounded-lg tw-px-2 hover:tw-bg-[#e5e6e6]">
                <FaIcon
                  icon={faPrint}
                  className="tw-h-4 tw-w-4 tw-text-[#2448bb]"
                />
                <span className="tw-text-sm tw-font-medium tw-text-[#2448bb]">
                  {t('driverModule.print-grouped-violations')}
                </span>
              </div>
            </Tooltip>

            <div className="tw-h-[18px] tw-w-px tw-bg-[#e5e6e6]"></div>

            <Tooltip
              text={t('driverModule.print-instruction')}
              onClick={() => handlePrintInstruction(printArgs())}
              blockedText={busyTooltip}
            >
              <div className="tw-flex tw-h-5 tw-items-center tw-gap-2 tw-rounded-lg tw-px-2 hover:tw-bg-[#e5e6e6]">
                <FaIcon
                  icon={faFileInvoice}
                  className="tw-h-4 tw-w-4 tw-text-[#2448bb]"
                />
                <span className="tw-text-sm tw-font-medium tw-text-[#2448bb]">
                  {t('driverModule.print-instruction')}
                </span>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>

     
    </div>
  )
}

export default ViolationsSelectedActionBar
